
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './header';
import Banner from './Banner';
// import Gallery from './Gallery';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Banner />
        {/* <Gallery /> */}
      </div>
    </Router>
  );
}

export default App;
